"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
require("./styles.scss");
var model_1 = require("../../model");
var PortalPage_1 = require("../_shared/components/PortalPage");
var Page = /** @class */ (function (_super) {
    __extends(Page, _super);
    function Page(props) {
        return _super.call(this, props) || this;
    }
    Page.prototype.render = function () {
        return React.createElement(PortalPage_1.default, { page: model_1.Permission.PAGE_SETTINGS, id: "settings-page", isLoading: this.props.isLoading });
    };
    return Page;
}(React.Component));
exports.Page = Page;
var mapStateToProps = function (_a) {
    var reducer = _a.reducer;
    return {
        isLoading: reducer.SettingsReducer.isLoading,
    };
};
var SettingsPage = (0, react_redux_1.connect)(mapStateToProps)(Page);
exports.default = SettingsPage;
